import LinkButton from '@components/atoms/buttons/LinkButton';
import ErrorMessage from '@components/atoms/ErrorMessage';
import FormField from '@components/atoms/FormField';
import GridBox from '@components/atoms/GridBox';
import OnboardingButtonBar from '@components/molecules/button-bar/OnboardingButtonBar';
import { Maybe } from '@graphql/generated';
import { BonusFormResult, QuoteInitialForm } from '@lib/data/typesQuestions';
import { trackEvent } from '@lib/services/analytics';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';

const list = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

function generateLabelValue(item?: Maybe<number>) {
  return item ? { label: item, value: item } : null;
}

interface Props {
  onSubmit: (data: BonusFormResult) => void;
  loading: boolean;
  item: QuoteInitialForm;
}

const ActualBonusForm = ({ onSubmit, item }: Props) => {
  const { handleSubmit, errors, control } = useForm<{
    bonus: { value: number };
  }>();
  return (
    <form
      onSubmit={handleSubmit((data) => {
        if (!item.oldPolicy) return null;

        return onSubmit({
          oldPolicy: {
            ...item.oldPolicy,
            bonus: Number(data.bonus.value),
          },
        });
      })}
    >
      <GridBox justifyContent="center">
        <GridBox width={[1, 0.5, 0.5]}>
          <FormField style={{ width: '100%' }}>
            <Controller
              name="bonus"
              control={control}
              rules={{ required: 'Precisamos do bônus' }}
              defaultValue={generateLabelValue(item.oldPolicy?.bonus)}
              render={(field) => (
                <Select
                  {...field}
                  options={list.map((i) => ({
                    label: i,
                    value: i,
                  }))}
                  placeholder="Selecione o bônus"
                  noOptionsMessage={() => 'Não encontrado'}
                />
              )}
            />
            {(errors.bonus as { message?: string })?.message && (
              <ErrorMessage>
                {(errors.bonus as { message?: string }).message}
              </ErrorMessage>
            )}
          </FormField>
        </GridBox>
      </GridBox>
      <GridBox justifyContent="center">
        <LinkButton
          onClick={() => {
            if (!item.oldPolicy) return;

            trackEvent('skipped bonus step');
            onSubmit({
              oldPolicy: {
                ...item.oldPolicy,
                bonus: 0,
              },
            });
          }}
        >
          Não sei meu bônus
        </LinkButton>
      </GridBox>
      <OnboardingButtonBar text="Continuar" loading={false} />
    </form>
  );
};

export default ActualBonusForm;
